export default "__VITE_ASSET__Dx81B0Bl__"